import productFileHtml from './productFile.html';

class ProductFileController {

    constructor($scope, $timeout, $http, translateService) {
        'ngInject';

        this.$http = $http;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.file = null;
        this.replace = false;
        this.allowedMimeTypes = ['cdr', 'svg', 'text/plain', 'image/svg+xml', 'application/cdr', 'application/coreldraw', 'application/x-cdr', 'application/x-coreldraw', 'application/vnd.corel-draw', 'image/cdr', 'image/x-cdr', 'image/x-coreldraw', 'zz-application/zz-winassoc-cdr'];
        this.allowedExtensions = ['cdr', 'svg'];
        this.error = false;
        this.success = false;
        this.translate = translateService;
        this.saving = false;

        this.processResponse = (response) => {
            this.saving = false;
            if (response.data.status === 'error') {
                this.error = response.data.message;

                this.$timeout(() => {
                    this.error = false;
                }, 5000);
            } else {
                this.success = response.data.message;

                this.$timeout(() => {
                    this.success = false;
                }, 5000);

                this.replace = false;
                this.onUpdate();
            }
        }
    }

    toggleReplace() {
        this.replace = true;
    }

    validateProductFile() {
        this.error = false;

        if (!this.file) {
            return;
        }

        if (this.file && this.allowedMimeTypes.indexOf(this.file.fileType) == -1) {
            this.error = this.translate.t('configuratorManual.errors.invalidExtension', { allowedExtensions: 'CDR, SVG' });
            return;
        }

        if (this.file && this.file.fileSize > 10000240) {
            this.error = this.translate.t('configuratorManual.errors.maximumFileSize', { filesize: '10 MB' });
            return;
        }

        return true;
    }

    replaceProductFile() {
        this.saving = true;

        if (!this.validateProductFile()) {
            this.saving = false;
            return;
        }

        const form = new FormData();

        let fileName = this.file.fileName;

        form.append('order_item_id', this.product.id);
        form.append('file', this.file.fileFormData.get('file'), fileName);

        this.$http.post('/admpanel/ajax/configurator/order/addAdminProductionFile', form, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        }).then(
            this.processResponse,
            () => {
                this.product = null;
                alert(this.translate.t('configuratorManual.errors.unexpected'));
                this.saving = false;
            }
        );
    }

    deleteProductFile() {
        if (!window.confirm('Czy chcesz usunąć plik produkcyjny?')) {
            return;
        }

        this.saving = true;

        const form = new FormData();

        form.append('order_item_id', this.product.id);

        this.$http.post('/admpanel/ajax/configurator/order/deleteAdminProductionFile', form, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        }).then(
            this.processResponse,
            () => {
                this.product = null;
                alert(this.translate.t('configuratorManual.errors.unexpected'));
                this.saving = false;
            }
        );
    }
}

let productFileComponent = {
    bindings: {
        'product': '<',
        'delete': '<',
        'onUpdate': '&'
    },
    template: productFileHtml,
    controller: ProductFileController
};

export default productFileComponent;